export default __webpack_public_path__ + "static/media/b2help-dobitnik.9d4eae3e.jpg";